<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useNetworkStatus } from '@/shared/composables/use-network-status'

const { t } = useI18n()
const { offline } = useNetworkStatus()
</script>

<template>
  <div
    v-if="offline"
    class="net-offline-banner"
    role="alert"
  >
    <p class="net-offline-banner__title">{{ t('common.offlineTitle') }}</p>
    <p class="net-offline-banner__hint">{{ t('common.offlineHint') }}</p>
  </div>
</template>

<style scoped>
.net-offline-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10050;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
  padding: 0.625rem 1rem;
  background: #b91c1c;
  color: #fff;
  text-align: center;
  box-shadow: 0 8px 24px rgba(127, 29, 29, 0.28);
}

.net-offline-banner__title {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.3;
}

.net-offline-banner__hint {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.35;
  color: #fecaca;
}
</style>
